const INTRO_MEMBERSHIP_PLAN = {
  price: {
    Yearly: 50,
    Monthly: 50,
    'Half year': 50
  },
  name: 'מנוי הכרות',
  value: 'INTRO_MEMBERSHIP_PLAN'
};

const HOOD_MEMBERSHIP_PLAN = {
  price: {
    Yearly: 315,
    Monthly: 350,
    'Half year': 330
  },
  discountedMonth: '50 ש״ח בלבד!',
  name: 'מנוי שכונתי',
  value: 'HOOD_MEMBERSHIP_PLAN'
};

const HOOD_FULL_MEMBERSHIP_PLAN = {
  price: {
    Yearly: 490,
    Monthly: 550,
    'Half year': 520
  },
  name: 'מנוי שכונתי מלא',
  value: 'HOOD_FULL_MEMBERSHIP_PLAN'
};

export default {
  INTRO_MEMBERSHIP_PLAN,
  HOOD_MEMBERSHIP_PLAN,
  HOOD_FULL_MEMBERSHIP_PLAN
};

export function getPlanByServerValue(serverValue) {
  switch (serverValue) {
    case 'Hood membership':
      return HOOD_MEMBERSHIP_PLAN;
    case 'Hood full membership':
      return HOOD_FULL_MEMBERSHIP_PLAN;
    case 'Intro membership':
      return INTRO_MEMBERSHIP_PLAN;
    default:
      return undefined;
  }
}

export function getPlanByClientValue(serverValue) {
  switch (serverValue) {
    case 'HOOD_MEMBERSHIP_PLAN':
      return HOOD_MEMBERSHIP_PLAN;
    case 'HOOD_FULL_MEMBERSHIP_PLAN':
      return HOOD_FULL_MEMBERSHIP_PLAN;
    case 'INTRO_MEMBERSHIP_PLAN':
      return INTRO_MEMBERSHIP_PLAN;
    default:
      return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/constants/plans.js